/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Aicost_1_KInputs */

const en_mk_aicost_1_k = /** @type {(inputs: Mk_Aicost_1_KInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One ordinary agent task`)
};

const id_mk_aicost_1_k = /** @type {(inputs: Mk_Aicost_1_KInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu tugas agen biasa`)
};

/**
* | output |
* | --- |
* | "One ordinary agent task" |
*
* @param {Mk_Aicost_1_KInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_aicost_1_k = /** @type {((inputs?: Mk_Aicost_1_KInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Aicost_1_KInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_aicost_1_k(inputs)
	return en_mk_aicost_1_k(inputs)
});